import { render, staticRenderFns } from "./cart_confirm.vue?vue&type=template&id=38f670be&scoped=true"
import script from "./cart_confirm.vue?vue&type=script&lang=js"
export * from "./cart_confirm.vue?vue&type=script&lang=js"
import style0 from "./cart_confirm.vue?vue&type=style&index=0&id=38f670be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f670be",
  null
  
)

export default component.exports